<div class="row g-4 mb-3">
  @if (isAllow) {
    <div class="col-sm-auto">
      <div>
        <button type="button" class="btn btn-success add-btn me-1" routerLink="questionnaire/create" [disabled]="current_client.plan === null">
          <i class="ri-add-line align-bottom me-1"></i> Create new questionnaire </button>
        </div>
      </div>
    }
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end">
        <div class="search-box ms-2">
          <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th class="sort" listsortable="name" (listsort)="onSort($event)">Name</th>
          <th>Status</th>
          <th>Created By</th>
          <th>Create Date</th>
          @if (isAllow) {
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="6" class="text-center">
              <app-loading-spinner></app-loading-spinner>
            </td>
          </tr>
        }
        @if (!loading && questionnaires && questionnaires.length > 0) {
          @for (questionnaire of questionnaires; track questionnaire) {
            <tr>
              <td>
                <ngb-highlight [result]="questionnaire.name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <span class="badge bg-{{ getStatusColor(questionnaire.status) }}-subtle text-{{ getStatusColor(questionnaire.status) }} fs-11">{{ questionnaire.status | titlecase }}</span>
              </td>
              <td>{{ questionnaire.user!.person.first_name + ' ' + questionnaire.user!.person.last_name }}</td>
              <td>{{ questionnaire.createdAt | date: 'medium' }}</td>
              @if (isAllow) {
                <td>
                  <div class="d-flex gap-2">
                    <div class="edit">
                      <button (click)="previewQuestionnaire(questionnaire.id)" class="btn btn-sm btn-info edit-item-btn" ngbTooltip="Preview Questionnaire" alt="Preview Questionnaire">
                        <i class=" ri-eye-line align-middle"></i>
                      </button>
                    </div>
                    @if (questionnaire.status === 'ACTIVE') {
                      <div (click)="inviteExaminee(questionnaire)" class="edit">
                        <button class="btn btn-sm btn-success edit-item-btn" ngbTooltip="Invite Examinee" alt="Invite Examinee">
                          <i class="ri-mail-send-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if (questionnaire.examineeCount === 0) {
                      <div class="edit">
                        <button routerLink="questionnaire/edit/{{ questionnaire.id }}" class="btn btn-sm btn-warning edit-item-btn" ngbTooltip="Edit Questionnaire" alt="Edit Questionnaire">
                          <i class="ri-edit-line align-middle"></i>
                        </button>
                      </div>
                    }
                    <div class="edit">
                      <button (click)="openCloneQuestionnaireModal(questionnaire.id)" class="btn btn-sm btn-primary edit-item-btn" ngbTooltip="Clone Questionnaire" alt="Clone Questionnaire">
                        <i class="ri-file-copy-2-line align-middle"></i>
                      </button>
                    </div>
                    @if (questionnaire.examineeCount === 0) {
                      <div class="remove">
                        <button (click)="openDeleteQuestionnaireModal(questionnaire)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Delete Questionnaire" alt="Delete Questionnaire">
                          <i class="ri-delete-bin-line align-middle"></i>
                        </button>
                      </div>
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (!loading && questionnaires && questionnaires.length === 0) {
          <tr>
            @if (isAllow) {
              <td colspan="5" class="text-center">No questionnaires found.</td>
            }
            @if (!isAllow) {
              <td colspan="4" class="text-center">No questionnaires found.</td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!loading && questionnaires && questionnaires.length > 0) {
    <div class="row justify-content-md-between align-items-md-center">
      <div class="col col-sm-6">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalQuestionnaires}} entries </div>
      </div>
      <div class="col col-sm-6">
        <div class="text-sm-right float-end listjs-pagination">
          <ngb-pagination [collectionSize]="totalQuestionnaires" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getQuestionnaires()"></ngb-pagination>
        </div>
      </div>
    </div>
  }

  <ng-template #deleteQuestionnaireModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to delete</h4>
            <h4><span class="fw-semibold text-warning">{{ selectedQuestionnaire.name }}</span>?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteQuestionnaire()" [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
          @if (!success) {
            <p class="text-muted mx-4 mb-0">{{ message }}</p>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #cloneQuestionnaireModal let-modal>
    <div class="modal-content">
      <div class="modal-header p-3">
        <h4 class="card-title mb-0">Clone Questionnaire</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="clone_questionnaire_name" class="form-label">Chapter Name</label>
          <input type="text" class="form-control" id="clone_questionnaire_name" placeholder="Enter questionnaire name" [(ngModel)]="cloned_questionnaire_name" [ngClass]="{ 'is-invalid': submitted && !cloned_questionnaire_name }">
        </div>
        <div class="mb-3">
          <label for="project" class="form-label">
            Clone to project (Optional)
            <i class="ri-information-fill align-bottom" ngbTooltip="Select a project to clone to - default project will be the current project" placement="bottom"></i>
          </label>
          <ng-select id="project" [items]="projects" bindLabel="name" bindValue="id" [loading]="loading" placeholder="Select parent project" [(ngModel)]="cloned_project_id" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !cloned_project_id }">
            <ng-template ng-loadingspinner-tmp>
              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="text-end">
          <button type="button" (click)="cloneQuestionnaire()" class="btn btn-primary btn-load" [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> Clone </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <app-preview-questionnaire #previewQuestionnaireModal></app-preview-questionnaire>
  <app-invite-examinee #inviteExamineeModal (examineeChanged)="getQuestionnaires()"></app-invite-examinee>
